import { action } from "typesafe-actions";
import ActionTypes from "./constants";

export const getMMVDataRequest = () => action(ActionTypes.GET_MMV_DATA_REQUEST);

export const getMMVDataSuccess = (data: any) =>
  action(ActionTypes.GET_MMV_DATA_SUCCESS, data);

export const getMMVDataFailure = (data: any) =>
  action(ActionTypes.GET_MMV_DATA_FAILURE, data);
